import { MAP_CENTRAL_ADMIN_GROUP_ID, MAP_PROVINCE_GROUP_ID } from '~/constants/map';
import { useAppSelector } from '~/redux/hooks';
import AdminMapView from './AdminMapView';
import ProvinceMapView from './ProvinceMapView';
import WardMapView from './WardMapView';

function Map() {
  const userProfile = useAppSelector((state) => state.auth.userProfile);
  const groupid = userProfile?.groupid;

  if (groupid === MAP_CENTRAL_ADMIN_GROUP_ID) {
    return <AdminMapView />;
  }

  if (groupid === MAP_PROVINCE_GROUP_ID) {
    return <ProvinceMapView />;
  }

  return <WardMapView />;
}

export default Map;
